export const themeColor = (hex) => {
    if (hex.startsWith('rgba')) {
        return hex.slice(5, -1).split(',').slice(0, -1).join(',');
    }
    if (hex.startsWith('rgb')) {
        return hex.slice(4, -1);
    }
    const hex2rgb = (hex) => {
        const rgbShorthandRegex = /^([a-f\d])([a-f\d])([a-f\d])$/i;
        const rgbRegex = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
        const parse16 = (x) => parseInt(x, 16);
        const fullHex = hex.slice(1).replace(rgbShorthandRegex, (_, r, g, b) => {
            return r + r + g + g + b + b;
        });
        const [ok, r, g, b] = fullHex.match(rgbRegex) || [];
        return ok ? [r, g, b].map(parse16) : null;
    };
    const rgb = hex2rgb(hex);
    if (!rgb) {
        console.warn(`Invalid hex: ${hex}`);
        return hex;
    }
    return rgb.join(', ');
};
export const obj2var = (x = {}, transform = (x) => `${x}`) => Object.entries(x)
    .map(([k, v]) => {
    return `--${k}: ${transform(v)};`;
})
    .join('\n');
export const obj2color = (x = {}) => obj2var(x, themeColor);
//# sourceMappingURL=transformer.js.map